import { useCallback } from 'react'
import { type FiltersFormModel } from '../formConfig'
import {
  useSchedulingWizard,
  toResultsActionCreator as toResults,
} from '../../wizardContext'

export function useOnSubmit() {
  const [, dispatch] = useSchedulingWizard()

  const onSubmit = useCallback(
    async (values: FiltersFormModel) => dispatch(toResults(values)),
    [dispatch],
  )

  return onSubmit
}
